import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonCard = ({ index }: { index: number }) => {
  return (
    <div
      className="border border-zinc-200 rounded-lg font-SFProDisplay min-h-[80px]"
      key={index}
    >
      <div className="px-6 pt-4">
        <div className="flex justify-between">
          <div className="flex items-start gap-2">
            <p className="text-blue-950 text-base font-semibold uppercase">
              <Skeleton height={15} width={100} />
            </p>
            <p className="text-rose-500 text-sm font-normal mt-[1px] capitalize">
              <Skeleton height={15} width={50} />
            </p>
          </div>
          <div className="flex gap-6">
            <div className="items-start">
              <Skeleton height={10} width={70} />
              <Skeleton height={8} width={100} />
            </div>
            <Skeleton circle height={30} width={30} />
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-[-12px]">
          <div className=" h-4 px-[5px] py-1  justify-center items-center gap-2.5 inline-flex">
            <Skeleton height={12} width={50} />
            <Skeleton height={12} width={50} />
            <Skeleton height={12} width={50} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
